import { useEffect } from "react";

let lockCount = 0;
let savedScrollY = 0;
let savedBodyStyle: Partial<CSSStyleDeclaration> = {};
let savedHtmlStyle: Partial<CSSStyleDeclaration> = {};

export function useBodyScrollLock(enabled: boolean) {
  useEffect(() => {
    if (!enabled || typeof window === "undefined" || typeof document === "undefined") return;

    lockCount += 1;
    if (lockCount === 1) {
      savedScrollY = window.scrollY;
      savedBodyStyle = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        right: document.body.style.right,
        width: document.body.style.width,
        overflow: document.body.style.overflow
      };
      savedHtmlStyle = {
        overflow: document.documentElement.style.overflow,
        overscrollBehavior: document.documentElement.style.overscrollBehavior
      };

      document.body.style.position = "fixed";
      document.body.style.top = `-${savedScrollY}px`;
      document.body.style.left = "0";
      document.body.style.right = "0";
      document.body.style.width = "100%";
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      document.documentElement.style.overscrollBehavior = "none";
    }

    return () => {
      lockCount = Math.max(0, lockCount - 1);
      if (lockCount > 0) return;

      document.body.style.position = savedBodyStyle.position || "";
      document.body.style.top = savedBodyStyle.top || "";
      document.body.style.left = savedBodyStyle.left || "";
      document.body.style.right = savedBodyStyle.right || "";
      document.body.style.width = savedBodyStyle.width || "";
      document.body.style.overflow = savedBodyStyle.overflow || "";
      document.documentElement.style.overflow = savedHtmlStyle.overflow || "";
      document.documentElement.style.overscrollBehavior = savedHtmlStyle.overscrollBehavior || "";
      window.scrollTo(0, savedScrollY);
    };
  }, [enabled]);
}
